import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { PayPalButton } from "react-paypal-button-v2";
import {
  Row,
  Form,
  Col,
  Image,
  Button,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import Loader from "../components/Loader";
import Message from "../components/Message";
import { Link } from "react-router-dom";
import { DateTime } from "luxon";
import {
  getOrderDetails,
  payOrder,
  deliverOrder,
  editOrder,
} from "../actions/orderActions";
import {
  ORDER_PAY_RESET,
  ORDER_DELIVER_RESET,
  ORDER_EDIT_RESET,
} from "../constants/orderConstants";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { initMercadoPago, Wallet } from "@mercadopago/sdk-react";

let initialOptions = {
  "client-id": "",
  currency: "MXN",
  intent: "capture",
};

// const customization = {
//  texts: {
//    action: 'buy',
//    valueProp: 'security_details',
//  },
//  visual: {
//      buttonBackground: 'black',
//      borderRadius: '6px',
//      buttonHeight: "48px",
//  },
// }

const OrderScreen = ({ match }) => {
  const windowWidth = useRef(window.innerWidth);
  //console.log("windowWidth: " + windowWidth.current);
  const navigate = useNavigate();
  const orderId = useParams().id;
  const [sdkReady, setSdkReady] = useState(false);
  //const orderId = match.params.id;
  const dispatch = useDispatch();

  const orderDetails = useSelector((state) => state.orderDetails);
  const { order, loading, error } = orderDetails;

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const orderPay = useSelector((state) => state.orderPay);
  const { loading: loadingPay, success: successPay } = orderPay;

  const [preferenceId, setPreferenceId] = useState(null);
  const [shippingCompany, setShippingCompany] = useState(null);
  const [shippingNumber, setShippingNumber] = useState(null);

   const mpInitRef = useRef(false);        // <-- guard MP init
   const prefCreatingRef = useRef(false);  // <-- guard preference creation

  // if (process.env.REACT_APP_NODE_ENV === "production") {
  //   initMercadoPago(process.env.REACT_APP_MERCADO_PAGO_PUBLIC_KEY_PROD);
  // } else {
  //   initMercadoPago(process.env.REACT_APP_MERCADO_PAGO_PUBLIC_KEY);
  // }

  // Initialize Mercado Pago SDK only once
  useEffect(() => {
    if (mpInitRef.current) return;
    const pk =
      process.env.NODE_ENV === "production"
        ? process.env.REACT_APP_MERCADO_PAGO_PUBLIC_KEY_PROD
        : process.env.REACT_APP_MERCADO_PAGO_PUBLIC_KEY;
    if (pk) {
      initMercadoPago(pk, { locale: "es-MX" });
      mpInitRef.current = true;
    }
  }, []);

  const orderDeliver = useSelector((state) => state.orderDeliver);
  const {
    loading: loadingDeliver,
    success: successDeliver,
    error: errorDeliver,
  } = orderDeliver;

  const orderEditState = useSelector((state) => state.orderEdit || {});
  const {
    loading: loadingEdit,
    success: successEdit,
    error: errorEdit,
  } = orderEditState;

  // Local edit-mode UI state. We only allow editing while the order is in the
  // "pending payment" lifecycle stage. Editable scope: shipping address +
  // items. Totals always recompute server-side.
  const [editAddressOpen, setEditAddressOpen] = useState(false);
  const [editItemsOpen, setEditItemsOpen] = useState(false);
  const [addressDraft, setAddressDraft] = useState({
    address: "",
    city: "",
    state: "",
    postalCode: "",
    country: "México",
    tel: "",
  });
  const [itemsDraft, setItemsDraft] = useState([]);

  // When the order arrives or is refreshed, reset the drafts to match.
  useEffect(() => {
    if (order && order.shippingAddress) {
      setAddressDraft({
        address: order.shippingAddress.address || "",
        city: order.shippingAddress.city || "",
        state: order.shippingAddress.state || "",
        postalCode: order.shippingAddress.postalCode || "",
        country: order.shippingAddress.country || "México",
        tel: order.shippingAddress.tel || "",
      });
    }
    if (order && Array.isArray(order.orderItems)) {
      setItemsDraft(
        order.orderItems.map((it) => ({
          product: it.product,
          name: it.name,
          image: it.image,
          price: it.price,
          qty: it.qty,
        }))
      );
    }
  }, [order]);

  // Close edit panels and clear the edit-state slice on a successful save.
  useEffect(() => {
    if (successEdit) {
      setEditAddressOpen(false);
      setEditItemsOpen(false);
      dispatch({ type: ORDER_EDIT_RESET });
      // The total may have changed — build a fresh Mercado Pago preference
      // so the customer pays the updated amount.
      prefCreatingRef.current = false;
      setPreferenceId(null);
    }
  }, [successEdit, dispatch]);

  //console.log("order");
  //console.log(order);
  if (!loading) {
    const addDecimals = (num) => {
      return (Math.round(num * 100) / 100).toFixed(2);
    };

    order.itemsPrice = addDecimals(
      order.orderItems.reduce((acc, item) => acc + item.price * item.qty, 0)
    );
  }

  useEffect(() => {
    if (!userInfo) {
      navigate("/login");
    }

    const createPreference = async () => {
      let items = [
        {
          title: "Productos Hadacy",
          unit_price: order.totalPrice,
          quantity: 1,
          currency_id: "MXN",
          description: "Orden: " + order._id,
        },
      ];

      let payer = {
        name: userInfo.name,
        email: userInfo.email,
      };
      // await order.orderItems.forEach((item) => {
      //   items.push({
      //     title: item.name,
      //     unit_price: item.price,
      //     quantity: item.qty,
      //     currency_id: "MXN",
      //   });
      // });

      try {
        const response = await axios.post(
          "/api/mercadopago",
          {
            items,
            external_reference: orderId,
            payer,
          },
          {
            headers: {
              Authorization: `Bearer ${userInfo.token}`,
            },
          }
        );

        const { id } = response.data;
        return id;
      } catch (error) {
        console.log(error);
      }
    };

    const handleBuy = async () => {
      const id = await createPreference();
      if (id) {
        setPreferenceId(id);
      }
    };
    const addPayPalScript = async () => {
      //const { data: clientId } = await axios.get("/api/config/paypal");
      // const script = document.createElement("script");
      // script.type = "text/javascript";
      // script.src = `https://www.paypal.com/sdk/js?client-id=${clientId}&currency=MXN`;
      // script.async = true;
      // script.onload = () => {
      //   setSdkReady(true);
      // };
      // document.body.appendChild(script);
      // console.log("clientId");
      // console.log(clientId);

      let data = await axios.get("/api/config/paypal");
      initialOptions["client-id"] = data.data;
      //console.log("initialOptions");
      //console.log(initialOptions);
      setSdkReady(true);
    };

    if (!order || successPay || successDeliver) {
      dispatch({ type: ORDER_PAY_RESET });
      dispatch({ type: ORDER_DELIVER_RESET });
      dispatch(getOrderDetails(orderId));
    } else if (!order.isPaid) {
      if (!sdkReady) {
        addPayPalScript();
      }
      // if (!preferenceId) {
      //   handleBuy();
      // }
      // Create preference only once (prevents StrictMode double-run)
      if (!preferenceId && !prefCreatingRef.current) {
       prefCreatingRef.current = true;
       handleBuy();
     }
     // else {
     //   setSdkReady(true);
     // }
   }

    if (!order || order._id !== orderId) {
      dispatch(getOrderDetails(orderId));
    }
  }, [
    dispatch,
    orderId,
    order,
    successPay,
    successDeliver,
    preferenceId,
    userInfo,
    navigate,
    sdkReady,
  ]);

  useEffect(() => {
  prefCreatingRef.current = false;
  setPreferenceId(null);
}, [orderId]);

  const successPaymentHandler = (paymentResult) => {
    //console.log(paymentResult);
    dispatch(payOrder(orderId, paymentResult));
  };

  const deliverHandler = () => {
    //console.log("deliverHandler");
    dispatch(deliverOrder(order, shippingCompany, shippingNumber));
  };


  // Promo breakdown — renders as a section card under the products list
  // when the order has a "buy X get Y" promo with a per-tipo breakdown.
  // Returns plain divs styled with .hadacy-order-* classes so it slots
  // into the new card layout without needing ListGroup wrapping.
  const renderPromoBreakdown = () => {
    if (
      !order?.coupon ||
      order.coupon.Type !== "BUY_X_GET_Y_SAME_TIPO" ||
      !order.coupon.detail?.freeBreakdown?.length
    ) {
      return null;
    }
    const breakdown = order.coupon.detail.freeBreakdown;
    const matchField = order.coupon.detail.matchField || "tipo";

    return (
      <section className="hadacy-order-section">
        <h2 className="hadacy-order-section__title">Promoción aplicada</h2>
        <div className="hadacy-order-promo">
          <span className="hadacy-order-promo__name">{order.coupon.Name}</span>
          <ul className="hadacy-order-promo__list">
            {breakdown.map((b, idx) => {
              const keyLabel = b[matchField] || b.tipo || "—";
              const units = b.freeUnits || 0;
              const value = typeof b.freeValue === "number" ? b.freeValue : 0;
              return (
                <li key={idx}>
                  {units} unidad{units === 1 ? "" : "es"} gratis en{" "}
                  <em>{keyLabel}</em>{" "}
                  <span className="hadacy-order-promo__amount">
                    (${value.toFixed(2)})
                  </span>
                </li>
              );
            })}
          </ul>
        </div>
      </section>
    );
  };

  // Coupon line(s) inside the right-hand Resumen card. Returns a single
  // .hadacy-order-summary__row div (or null) to slot between the other
  // numeric rows.
  const renderSummaryCouponLines = () => {
    if (!order?.coupon) return null;

    if (order.coupon.Type === "BUY_X_GET_Y_SAME_TIPO") {
      const amount =
        typeof order.coupon.appliedDiscountAmount === "number"
          ? order.coupon.appliedDiscountAmount
          : 0;
      if (amount <= 0) return null;
      return (
        <div className="hadacy-order-summary__row hadacy-order-summary__row--discount">
          <span>Descuento promoción</span>
          <span>−${amount.toFixed(2)}</span>
        </div>
      );
    }

    if (order.coupon.Type === "PERCENT") {
      const pct = Number(order.coupon.Discount || 0);
      if (pct <= 0) return null;
      const before = Number(order.coupon.beforeDiscount || order.totalPrice);
      const after = Number(order.totalPrice || 0);
      const amount = Math.max(0, before - after);
      return (
        <div className="hadacy-order-summary__row hadacy-order-summary__row--discount">
          <span>Descuento cupón ({pct}%)</span>
          <span>−${amount.toFixed(2)}</span>
        </div>
      );
    }
    return null;
  };

  // Full order ID, uppercased so it reads as a "reference number".
  const fullOrderId = order?._id ? order._id.toUpperCase() : "";

  // Owner-or-admin gate. Server enforces the same check, this just hides UI.
  const orderUserId =
    order?.user && (order.user._id || order.user.id || order.user);
  const isOwner =
    userInfo &&
    orderUserId &&
    String(userInfo._id) === String(orderUserId);
  const canEdit =
    order &&
    !order.isPaid &&
    !order.isDelivered &&
    !order.isCanceled &&
    (isOwner || (userInfo && userInfo.isAdmin));

  const saveAddress = () => {
    const a = addressDraft;
    if (!a.address || !a.city || !a.state || !a.postalCode || !a.tel) return;
    dispatch(editOrder(orderId, { shippingAddress: a }));
  };

  const saveItems = () => {
    if (!itemsDraft.length) return;
    dispatch(
      editOrder(orderId, {
        orderItems: itemsDraft.map((it) => ({
          product: it.product,
          qty: Math.max(1, Number(it.qty) || 1),
        })),
      })
    );
  };

  const updateDraftQty = (idx, qty) => {
    setItemsDraft((prev) =>
      prev.map((it, i) =>
        i === idx ? { ...it, qty: Math.max(1, Number(qty) || 1) } : it
      )
    );
  };

  const removeDraftItem = (idx) => {
    setItemsDraft((prev) => prev.filter((_, i) => i !== idx));
  };

  const cancelAddressEdit = () => {
    if (order?.shippingAddress) {
      setAddressDraft({
        address: order.shippingAddress.address || "",
        city: order.shippingAddress.city || "",
        state: order.shippingAddress.state || "",
        postalCode: order.shippingAddress.postalCode || "",
        country: order.shippingAddress.country || "México",
        tel: order.shippingAddress.tel || "",
      });
    }
    setEditAddressOpen(false);
  };

  const cancelItemsEdit = () => {
    if (order && Array.isArray(order.orderItems)) {
      setItemsDraft(
        order.orderItems.map((it) => ({
          product: it.product,
          name: it.name,
          image: it.image,
          price: it.price,
          qty: it.qty,
        }))
      );
    }
    setEditItemsOpen(false);
  };

  return loading ? (
    <Loader />
  ) : error ? (
    <Message variant="danger">{error}</Message>
  ) : (
    <div className="hadacy-order">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;0,600&family=Jost:wght@200;300;400;500&display=swap');

        /* ─── HADACY · order detail screen ─── */
        .hadacy-order {
          --cream: #f5f0e8;
          --dark: #1a1410;
          --gold: #b8933a;
          --gold-light: #d4af6a;
          --muted: #7a6e62;
          --card-bg: #faf7f2;
          --recess: #efe7d8;
          --hairline: rgba(184, 147, 58, 0.18);
          --danger-bg: #fbe9e6;
          --danger-fg: #a94139;
          --danger-border: rgba(220, 53, 69, 0.35);
          --success-bg: #eef6e9;
          --success-fg: #3a6b3a;
          --success-border: rgba(40, 167, 69, 0.32);
          font-family: "Jost", sans-serif;
          color: var(--dark);
        }

        /* ── Page header: little label + monospace-ish ID + status pills */
        .hadacy-order__header {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          align-items: flex-end;
          gap: 1rem 1.5rem;
          margin: 0 0 1.5rem 0;
          padding-bottom: 0.85rem;
          border-bottom: 1px solid var(--hairline);
        }
        .hadacy-order__label {
          display: block;
          font-size: 0.62rem;
          letter-spacing: 0.22em;
          text-transform: uppercase;
          color: var(--muted);
          margin-bottom: 0.25rem;
        }
        .hadacy-order__title {
          font-family: "Jost", sans-serif;
          font-weight: 400;
          font-size: 1rem;
          letter-spacing: 0.18em;
          margin: 0;
          color: var(--dark);
          word-break: break-all;        /* let the long ID wrap on narrow viewports */
          overflow-wrap: anywhere;
        }
        .hadacy-order__statuses {
          display: flex;
          gap: 0.55rem;
          flex-wrap: wrap;
        }
        /* Same pill shape as the orders-list cards so the language is
           consistent across the profile page → order detail page. */
        .hadacy-order__pill {
          display: inline-flex;
          align-items: center;
          gap: 0.55rem;
          padding: 0.4rem 0.95rem;
          border-radius: 999px;
          border: 1px solid;
          font-size: 0.74rem;
          letter-spacing: 0.06em;
        }
        .hadacy-order__pill i { font-size: 0.85rem; }
        .hadacy-order__pill--ok {
          background: rgba(184, 147, 58, 0.10);
          border-color: rgba(184, 147, 58, 0.45);
          color: var(--gold);
        }
        .hadacy-order__pill--pending {
          background: var(--recess);
          border-color: rgba(122, 110, 98, 0.32);
          color: var(--muted);
        }

        /* ── Section card: shared shell for shipping / payment / products /
              promo / deliver. Hairline gold-tinted border, soft shadow on
              hover, generous interior padding. */
        .hadacy-order-section {
          background: var(--card-bg);
          border: 1px solid var(--hairline);
          border-radius: 14px;
          padding: 1.25rem 1.4rem;
          margin-bottom: 1.1rem;
          transition: border-color .2s ease, box-shadow .2s ease;
        }
        .hadacy-order-section:hover {
          border-color: rgba(184, 147, 58, 0.4);
          box-shadow: 0 10px 24px rgba(26, 20, 16, 0.06);
        }
        .hadacy-order-section__title {
          font-family: "Cormorant Garamond", serif;
          font-weight: 400;
          letter-spacing: 0.04em;
          font-size: 1.4rem;
          color: var(--dark);
          margin: 0 0 1rem 0;
          padding-bottom: 0.5rem;
          position: relative;
        }
        .hadacy-order-section__title::after {
          content: "";
          position: absolute;
          left: 0;
          bottom: 0;
          width: 36px;
          height: 1px;
          background: var(--gold);
        }

        /* ── Info rows (label + value, stacked) inside section cards */
        .hadacy-order-info {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
          gap: 0.85rem 1.5rem;
          margin-bottom: 1rem;
        }
        .hadacy-order-info__row {
          display: flex;
          flex-direction: column;
          gap: 0.15rem;
          min-width: 0;
        }
        .hadacy-order-info__row--full { grid-column: 1 / -1; }
        .hadacy-order-info__label {
          font-size: 0.6rem;
          letter-spacing: 0.22em;
          text-transform: uppercase;
          color: var(--muted);
        }
        .hadacy-order-info__value {
          font-size: 0.92rem;
          color: var(--dark);
          word-break: break-word;
        }
        .hadacy-order-info__value a {
          color: var(--gold) !important;
          text-decoration: none;
        }
        .hadacy-order-info__value a:hover { text-decoration: underline; }

        /* ── Status banners replace the old red/green Bootstrap Messages.
              Same vocabulary as the pills but full-width inside the card. */
        .hadacy-order-banner {
          display: flex;
          align-items: center;
          gap: 0.65rem;
          padding: 0.65rem 0.95rem;
          border-radius: 10px;
          border: 1px solid;
          font-size: 0.86rem;
          margin-top: 0.4rem;
        }
        .hadacy-order-banner i { font-size: 1rem; }
        .hadacy-order-banner--success {
          background: var(--success-bg);
          border-color: var(--success-border);
          color: var(--success-fg);
        }
        .hadacy-order-banner--danger {
          background: var(--danger-bg);
          border-color: var(--danger-border);
          color: var(--danger-fg);
        }

        /* ── Products list ── */
        .hadacy-order-products { display: flex; flex-direction: column; }
        .hadacy-order-product {
          display: grid;
          grid-template-columns: 80px 1fr auto;
          gap: 1rem;
          align-items: center;
          padding: 0.85rem 0;
        }
        .hadacy-order-product + .hadacy-order-product {
          border-top: 1px solid var(--hairline);
        }
        .hadacy-order-product__img {
          width: 80px;
          height: 80px;
          border-radius: 10px;
          overflow: hidden;
          background: var(--recess);
        }
        .hadacy-order-product__img img {
          width: 100%; height: 100%;
          object-fit: cover;
        }
        .hadacy-order-product__name {
          font-size: 0.95rem;
          color: var(--dark) !important;
          text-decoration: none !important;
          line-height: 1.35;
        }
        .hadacy-order-product__name:hover { color: var(--gold) !important; }
        .hadacy-order-product__qty {
          text-align: right;
          font-size: 0.85rem;
          color: var(--muted);
          line-height: 1.35;
          white-space: nowrap;
        }
        .hadacy-order-product__total {
          display: block;
          font-family: "Cormorant Garamond", serif;
          font-size: 1.1rem;
          color: var(--gold);
          letter-spacing: 0.02em;
        }

        /* ── Promo breakdown ── */
        .hadacy-order-promo__name {
          font-family: "Cormorant Garamond", serif;
          font-size: 1.1rem;
          color: var(--gold);
          display: inline-block;
          margin-bottom: 0.5rem;
        }
        .hadacy-order-promo__list {
          margin: 0;
          padding-left: 1.1rem;
          font-size: 0.9rem;
          color: var(--dark);
        }
        .hadacy-order-promo__list li { margin-bottom: 0.25rem; }
        .hadacy-order-promo__list em {
          font-style: italic;
          color: var(--muted);
        }
        .hadacy-order-promo__amount { color: var(--gold); }

        /* ── Right-hand Resumen card ── */
        .hadacy-order-summary {
          background: var(--card-bg);
          border: 1px solid var(--hairline);
          border-radius: 14px;
          padding: 1.25rem 1.4rem;
          position: sticky;
          top: 1rem;
        }
        .hadacy-order-summary__title {
          font-family: "Cormorant Garamond", serif;
          font-weight: 400;
          letter-spacing: 0.04em;
          font-size: 1.4rem;
          color: var(--dark);
          margin: 0 0 1rem 0;
          padding-bottom: 0.5rem;
          position: relative;
        }
        .hadacy-order-summary__title::after {
          content: "";
          position: absolute;
          left: 0;
          bottom: 0;
          width: 36px;
          height: 1px;
          background: var(--gold);
        }
        .hadacy-order-summary__rows {
          display: flex;
          flex-direction: column;
          gap: 0.55rem;
          padding: 0.25rem 0;
        }
        .hadacy-order-summary__row {
          display: flex;
          justify-content: space-between;
          gap: 0.75rem;
          font-size: 0.9rem;
          color: var(--dark);
          line-height: 1.45;
        }
        .hadacy-order-summary__row--muted { color: var(--muted); }
        .hadacy-order-summary__row--discount {
          color: var(--gold);
          font-style: italic;
        }
        .hadacy-order-summary__row span:first-child {
          color: var(--muted);
        }
        .hadacy-order-summary__row span:last-child {
          color: var(--dark);
          font-weight: 400;
        }
        .hadacy-order-summary__row--discount span:last-child {
          color: var(--gold);
        }
        .hadacy-order-summary__divider {
          height: 1px;
          background: var(--hairline);
          margin: 0.65rem 0;
        }
        .hadacy-order-summary__total {
          display: flex;
          justify-content: space-between;
          align-items: baseline;
          gap: 1rem;
          padding-top: 0.4rem;
        }
        .hadacy-order-summary__total .ho-total-label {
          font-size: 0.74rem;
          letter-spacing: 0.22em;
          text-transform: uppercase;
          color: var(--muted);
        }
        .hadacy-order-summary__total .ho-total-amount {
          font-family: "Cormorant Garamond", serif;
          font-size: 1.7rem;
          color: var(--dark);
          letter-spacing: 0.02em;
        }
        .hadacy-order-summary__before {
          color: var(--muted);
          text-decoration: line-through;
          font-size: 0.85rem;
          margin-right: 0.45rem;
        }
        .hadacy-order-summary__coupon-tag {
          display: inline-block;
          margin-top: 0.4rem;
          padding: 0.25rem 0.7rem;
          border-radius: 999px;
          background: rgba(184, 147, 58, 0.1);
          border: 1px solid rgba(184, 147, 58, 0.4);
          color: var(--gold);
          font-size: 0.7rem;
          letter-spacing: 0.06em;
        }
        .hadacy-order-summary__admin-tag {
          display: inline-block;
          margin-bottom: 0.5rem;
          padding: 0.2rem 0.65rem;
          border-radius: 999px;
          background: rgba(247, 195, 64, 0.18);
          border: 1px solid rgba(247, 195, 64, 0.55);
          color: #9a7308;
          font-size: 0.62rem;
          letter-spacing: 0.18em;
          text-transform: uppercase;
        }

        /* ── Mercado Pago / payment block ── */
        .hadacy-order-summary__pay {
          margin-top: 1rem;
          padding-top: 1rem;
          border-top: 1px solid var(--hairline);
        }

        /* ── Admin "Enviar Orden" form ── */
        .hadacy-order-deliver { padding-top: 0.25rem; }
        .hadacy-order-deliver .form-control {
          background: #fff !important;
          border: 1px solid rgba(184, 147, 58, 0.22) !important;
          border-radius: 10px !important;
          padding: 0.6rem 0.9rem !important;
          font-family: "Jost", sans-serif;
          font-size: 0.9rem;
          color: var(--dark) !important;
          box-shadow: none !important;
          margin-bottom: 0.85rem;
        }
        .hadacy-order-deliver .form-control:focus {
          border-color: var(--gold) !important;
          box-shadow: 0 0 0 3px rgba(184, 147, 58, 0.14) !important;
        }
        .hadacy-order-deliver__cta {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          gap: 0.55rem;
          padding: 0.7rem 1.5rem !important;
          border-radius: 999px !important;
          background: var(--dark) !important;
          border: 1px solid var(--dark) !important;
          color: var(--gold-light) !important;
          font-family: "Jost", sans-serif;
          font-size: 0.7rem;
          font-weight: 400;
          letter-spacing: 0.2em;
          text-transform: uppercase;
          transition: background .2s ease, color .2s ease, opacity .2s ease;
        }
        .hadacy-order-deliver__cta:hover:not(:disabled) {
          background: var(--gold) !important;
          border-color: var(--gold) !important;
          color: var(--dark) !important;
        }
        .hadacy-order-deliver__cta:disabled {
          opacity: 0.55;
          cursor: not-allowed;
        }

        @media (max-width: 575.98px) {
          .hadacy-order-product {
            grid-template-columns: 60px 1fr;
          }
          .hadacy-order-product__qty {
            grid-column: 1 / -1;
            text-align: left;
          }
          .hadacy-order-product__img { width: 60px; height: 60px; }
          .hadacy-order-summary { position: static; }
        }

        /* ── Section header with optional Edit / Save / Cancel actions ── */
        .hadacy-order-section__head {
          display: flex;
          align-items: baseline;
          justify-content: space-between;
          gap: 0.75rem;
          margin: 0 0 1rem;
        }
        .hadacy-order-section__head .hadacy-order-section__title {
          margin: 0;
        }
        .hadacy-order-section__actions {
          display: inline-flex;
          gap: 0.4rem;
          align-items: center;
        }
        .hadacy-order-section__btn {
          background: transparent;
          border: 0;
          padding: 0.35rem 0.75rem;
          border-radius: 999px;
          font-family: "Jost", sans-serif;
          font-size: 0.66rem;
          font-weight: 600;
          letter-spacing: 0.18em;
          text-transform: uppercase;
          color: var(--gold);
          cursor: pointer;
          transition: color .2s ease, background .2s ease;
        }
        .hadacy-order-section__btn:hover { color: var(--dark); }
        .hadacy-order-section__btn--primary {
          background: var(--dark);
          color: var(--cream);
          padding: 0.45rem 1rem;
        }
        .hadacy-order-section__btn--primary:hover {
          background: var(--gold);
          color: var(--cream);
        }
        .hadacy-order-section__btn--ghost {
          color: var(--muted);
        }
        .hadacy-order-section__btn:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }

        /* ── Inline address edit form ── */
        .hadacy-order-edit-form {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 0.75rem 1rem;
          margin-top: 0.5rem;
        }
        @media (max-width: 575.98px) {
          .hadacy-order-edit-form { grid-template-columns: 1fr; }
        }
        .hadacy-order-edit-form .hef-full { grid-column: 1 / -1; }
        .hadacy-order-edit-form label {
          display: block;
          font-size: 0.6rem;
          letter-spacing: 0.22em;
          text-transform: uppercase;
          color: var(--muted);
          margin-bottom: 0.3rem;
        }
        .hadacy-order-edit-form input {
          width: 100%;
          background: #fff;
          border: 1px solid var(--hairline);
          border-radius: 8px;
          padding: 0.6rem 0.85rem;
          font-family: "Jost", sans-serif;
          font-size: 0.9rem;
          color: var(--dark);
          transition: border-color .2s ease, box-shadow .2s ease;
        }
        .hadacy-order-edit-form input:focus {
          outline: none;
          border-color: var(--gold);
          box-shadow: 0 0 0 3px rgba(184, 147, 58, 0.14);
        }
        .hadacy-order-edit-form input:disabled {
          background: var(--recess);
          color: var(--muted);
          cursor: not-allowed;
        }
        .hadacy-order-edit-actions {
          display: flex;
          gap: 0.5rem;
          justify-content: flex-end;
          margin-top: 1rem;
          padding-top: 0.85rem;
          border-top: 1px solid var(--hairline);
        }

        /* ── Editable product rows: same grid as the read-only version
              but with qty controls and a remove button. */
        .hadacy-order-product--edit {
          grid-template-columns: 80px 1fr auto auto;
          gap: 1rem;
          align-items: center;
        }
        @media (max-width: 575.98px) {
          .hadacy-order-product--edit {
            grid-template-columns: 60px 1fr;
          }
          .hadacy-order-product--edit .hadacy-order-qty,
          .hadacy-order-product--edit .hadacy-order-product__remove {
            grid-column: 1 / -1;
            justify-self: start;
          }
        }
        .hadacy-order-qty {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          padding: 0.25rem 0.55rem;
          border: 1px solid var(--hairline);
          border-radius: 999px;
          background: var(--cream);
        }
        .hadacy-order-qty button {
          background: transparent;
          border: 0;
          width: 24px;
          height: 24px;
          font-size: 0.95rem;
          color: var(--gold);
          cursor: pointer;
          font-weight: 600;
        }
        .hadacy-order-qty button:disabled {
          opacity: 0.4;
          cursor: not-allowed;
        }
        .hadacy-order-qty span {
          min-width: 22px;
          text-align: center;
          font-size: 0.92rem;
          color: var(--dark);
          font-variant-numeric: tabular-nums;
        }
        .hadacy-order-product__remove {
          background: transparent;
          border: 0;
          padding: 0.4rem 0.6rem;
          color: var(--muted);
          cursor: pointer;
          border-radius: 999px;
          transition: color .2s ease, background .2s ease;
        }
        .hadacy-order-product__remove:hover {
          color: var(--danger-fg);
          background: var(--danger-bg);
        }

        /* Banner used for edit-success / edit-error feedback. */
        .hadacy-order-banner--info {
          background: rgba(184, 147, 58, 0.1);
          border-color: rgba(184, 147, 58, 0.4);
          color: var(--gold);
        }
      `}</style>

      <header className="hadacy-order__header">
        <div>
          <span className="hadacy-order__label">Orden</span>
          <h1 className="hadacy-order__title">#{fullOrderId}</h1>
        </div>
        <div className="hadacy-order__statuses">
          <span
            className={`hadacy-order__pill ${
              order.isPaid
                ? "hadacy-order__pill--ok"
                : "hadacy-order__pill--pending"
            }`}
          >
            <i
              className={
                order.isPaid ? "fas fa-check-circle" : "far fa-clock"
              }
            ></i>
            {order.isPaid ? "Pagado" : "Pago pendiente"}
          </span>
          <span
            className={`hadacy-order__pill ${
              order.isDelivered
                ? "hadacy-order__pill--ok"
                : "hadacy-order__pill--pending"
            }`}
          >
            <i
              className={
                order.isDelivered ? "fas fa-check-circle" : "fas fa-truck"
              }
            ></i>
            {order.isDelivered ? "Entregado" : "Por enviar"}
          </span>
        </div>
      </header>

      <Row>
        <Col md={windowWidth.current > 950 ? 8 : 12}>
          {/* ── Envío ── */}
          <section className="hadacy-order-section">
            <div className="hadacy-order-section__head">
              <h2 className="hadacy-order-section__title">Envío</h2>
              {canEdit && !editAddressOpen && (
                <div className="hadacy-order-section__actions">
                  <button
                    type="button"
                    className="hadacy-order-section__btn"
                    onClick={() => setEditAddressOpen(true)}
                  >
                    Editar
                  </button>
                </div>
              )}
            </div>
            <div className="hadacy-order-info">
              <div className="hadacy-order-info__row">
                <span className="hadacy-order-info__label">Nombre</span>
                <span className="hadacy-order-info__value">
                  {order.user.name}
                </span>
              </div>
              <div className="hadacy-order-info__row">
                <span className="hadacy-order-info__label">Email</span>
                <span className="hadacy-order-info__value">
                  <a href={`mailto:${order.user.email}`}>
                    {order.user.email}
                  </a>
                </span>
              </div>
              <div className="hadacy-order-info__row hadacy-order-info__row--full">
                <span className="hadacy-order-info__label">Dirección</span>
                <span className="hadacy-order-info__value">
                  {order.shippingAddress.address},{" "}
                  {order.shippingAddress.city},{" "}
                  {order.shippingAddress.state},{" "}
                  {order.shippingAddress.postalCode},{" "}
                  {order.shippingAddress.country}
                </span>
              </div>
              <div className="hadacy-order-info__row">
                <span className="hadacy-order-info__label">Teléfono</span>
                <span className="hadacy-order-info__value">
                  {order.shippingAddress.tel}
                </span>
              </div>
              {order.isPaid && order.paymentResultMercadoPago && (
                <div className="hadacy-order-info__row">
                  <span className="hadacy-order-info__label">
                    Referencia de pago
                  </span>
                  <span className="hadacy-order-info__value">
                    {order.paymentResultMercadoPago.collection_id}
                  </span>
                </div>
              )}
              {order.isDelivered && (
                <>
                  <div className="hadacy-order-info__row">
                    <span className="hadacy-order-info__label">
                      Compañía
                    </span>
                    <span className="hadacy-order-info__value">
                      {order.shippingCompany}
                    </span>
                  </div>
                  <div className="hadacy-order-info__row">
                    <span className="hadacy-order-info__label">
                      Número de rastreo
                    </span>
                    <span className="hadacy-order-info__value">
                      {order.shippingNumber}
                    </span>
                  </div>
                </>
              )}
            </div>
            {order.isDelivered ? (
              <div className="hadacy-order-banner hadacy-order-banner--success">
                <i className="fas fa-check-circle"></i>
                Enviado el{" "}
                {DateTime.fromISO(order.deliveredAt).toLocaleString(
                  DateTime.DATETIME_MED
                )}
              </div>
            ) : (
              <div className="hadacy-order-banner hadacy-order-banner--danger">
                <i className="fas fa-truck"></i>
                Sin enviar
              </div>
            )}

            {canEdit && editAddressOpen && (
              <>
                <div className="hadacy-order-edit-form">
                  <div className="hef-full">
                    <label htmlFor="ed-address">Dirección</label>
                    <input
                      id="ed-address"
                      type="text"
                      value={addressDraft.address}
                      onChange={(e) =>
                        setAddressDraft({ ...addressDraft, address: e.target.value })
                      }
                    />
                  </div>
                  <div>
                    <label htmlFor="ed-city">Ciudad</label>
                    <input
                      id="ed-city"
                      type="text"
                      value={addressDraft.city}
                      onChange={(e) =>
                        setAddressDraft({ ...addressDraft, city: e.target.value })
                      }
                    />
                  </div>
                  <div>
                    <label htmlFor="ed-state">Estado</label>
                    <input
                      id="ed-state"
                      type="text"
                      value={addressDraft.state}
                      onChange={(e) =>
                        setAddressDraft({ ...addressDraft, state: e.target.value })
                      }
                    />
                  </div>
                  <div>
                    <label htmlFor="ed-cp">Código postal</label>
                    <input
                      id="ed-cp"
                      type="text"
                      value={addressDraft.postalCode}
                      onChange={(e) =>
                        setAddressDraft({
                          ...addressDraft,
                          postalCode: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div>
                    <label htmlFor="ed-tel">Teléfono</label>
                    <input
                      id="ed-tel"
                      type="text"
                      value={addressDraft.tel}
                      onChange={(e) =>
                        setAddressDraft({
                          ...addressDraft,
                          tel: e.target.value.slice(0, 10),
                        })
                      }
                    />
                  </div>
                  <div>
                    <label htmlFor="ed-country">País</label>
                    <input
                      id="ed-country"
                      type="text"
                      value={addressDraft.country}
                      disabled
                      readOnly
                    />
                  </div>
                </div>
                {errorEdit && (
                  <div className="hadacy-order-banner hadacy-order-banner--danger" style={{ marginTop: "0.85rem" }}>
                    <i className="fas fa-exclamation-circle"></i>
                    {errorEdit}
                  </div>
                )}
                <div className="hadacy-order-edit-actions">
                  <button
                    type="button"
                    className="hadacy-order-section__btn hadacy-order-section__btn--ghost"
                    onClick={cancelAddressEdit}
                    disabled={loadingEdit}
                  >
                    Cancelar
                  </button>
                  <button
                    type="button"
                    className="hadacy-order-section__btn hadacy-order-section__btn--primary"
                    onClick={saveAddress}
                    disabled={
                      loadingEdit ||
                      !addressDraft.address ||
                      !addressDraft.city ||
                      !addressDraft.state ||
                      !addressDraft.postalCode ||
                      !addressDraft.tel
                    }
                  >
                    {loadingEdit ? "Guardando..." : "Guardar dirección"}
                  </button>
                </div>
              </>
            )}
          </section>

          {/* ── Método de Pago ── */}
          <section className="hadacy-order-section">
            <h2 className="hadacy-order-section__title">Método de Pago</h2>
            <div className="hadacy-order-info">
              <div className="hadacy-order-info__row">
                <span className="hadacy-order-info__label">Método</span>
                <span className="hadacy-order-info__value">
                  {order.paymentMethod || "—"}
                </span>
              </div>
            </div>
            {order.isPaid ? (
              <div className="hadacy-order-banner hadacy-order-banner--success">
                <i className="fas fa-check-circle"></i>
                Pagado el{" "}
                {DateTime.fromISO(order.paidAt).toLocaleString(
                  DateTime.DATETIME_MED
                )}
              </div>
            ) : (
              <div className="hadacy-order-banner hadacy-order-banner--danger">
                <i className="far fa-clock"></i>
                Sin pagar
              </div>
            )}
          </section>

          {/* ── Productos ── */}
          <section className="hadacy-order-section">
            <div className="hadacy-order-section__head">
              <h2 className="hadacy-order-section__title">Productos</h2>
              {canEdit && !editItemsOpen && (
                <div className="hadacy-order-section__actions">
                  <button
                    type="button"
                    className="hadacy-order-section__btn"
                    onClick={() => setEditItemsOpen(true)}
                  >
                    Editar
                  </button>
                </div>
              )}
            </div>
            {order.orderItems.length === 0 ? (
              <Message>Tu orden está vacía</Message>
            ) : !editItemsOpen ? (
              <div className="hadacy-order-products">
                {order.orderItems.map((item, index) => (
                  <div className="hadacy-order-product" key={index}>
                    <Link
                      to={`/product/${item.product}`}
                      className="hadacy-order-product__img"
                    >
                      <Image src={item.image} alt={item.name} fluid />
                    </Link>
                    <Link
                      to={`/product/${item.product}`}
                      className="hadacy-order-product__name"
                    >
                      {item.name}
                    </Link>
                    <div className="hadacy-order-product__qty">
                      {item.qty} × ${item.price}
                      <span className="hadacy-order-product__total">
                        ${item.qty * item.price}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <>
                <div className="hadacy-order-products">
                  {itemsDraft.map((item, idx) => (
                    <div
                      className="hadacy-order-product hadacy-order-product--edit"
                      key={item.product || idx}
                    >
                      <span className="hadacy-order-product__img">
                        <Image src={item.image} alt={item.name} fluid />
                      </span>
                      <div>
                        <span className="hadacy-order-product__name">
                          {item.name}
                        </span>
                        <div
                          className="hadacy-order-product__qty"
                          style={{ textAlign: "left", marginTop: "0.25rem" }}
                        >
                          ${item.price}
                          <span className="hadacy-order-product__total">
                            ${(item.price * item.qty).toFixed(2)}
                          </span>
                        </div>
                      </div>
                      <div className="hadacy-order-qty">
                        <button
                          type="button"
                          onClick={() => updateDraftQty(idx, item.qty - 1)}
                          disabled={item.qty <= 1}
                          aria-label="Disminuir cantidad"
                        >
                          −
                        </button>
                        <span>{item.qty}</span>
                        <button
                          type="button"
                          onClick={() => updateDraftQty(idx, item.qty + 1)}
                          aria-label="Aumentar cantidad"
                        >
                          +
                        </button>
                      </div>
                      <button
                        type="button"
                        className="hadacy-order-product__remove"
                        onClick={() => removeDraftItem(idx)}
                        aria-label={`Quitar ${item.name}`}
                        title="Quitar"
                      >
                        <i className="fas fa-trash"></i>
                      </button>
                    </div>
                  ))}
                  {itemsDraft.length === 0 && (
                    <div className="hadacy-order-banner hadacy-order-banner--danger">
                      <i className="fas fa-exclamation-circle"></i>
                      La orden debe tener al menos un producto.
                    </div>
                  )}
                </div>
                {errorEdit && (
                  <div className="hadacy-order-banner hadacy-order-banner--danger" style={{ marginTop: "0.85rem" }}>
                    <i className="fas fa-exclamation-circle"></i>
                    {errorEdit}
                  </div>
                )}
                <div className="hadacy-order-edit-actions">
                  <button
                    type="button"
                    className="hadacy-order-section__btn hadacy-order-section__btn--ghost"
                    onClick={cancelItemsEdit}
                    disabled={loadingEdit}
                  >
                    Cancelar
                  </button>
                  <button
                    type="button"
                    className="hadacy-order-section__btn hadacy-order-section__btn--primary"
                    onClick={saveItems}
                    disabled={loadingEdit || itemsDraft.length === 0}
                  >
                    {loadingEdit ? "Guardando..." : "Guardar productos"}
                  </button>
                </div>
              </>
            )}
          </section>

          {renderPromoBreakdown()}
        </Col>

        <Col md={windowWidth.current > 950 ? 4 : 12}>
          <aside className="hadacy-order-summary">
            <h2 className="hadacy-order-summary__title">Resumen</h2>

            <div className="hadacy-order-summary__rows">
              <div className="hadacy-order-summary__row">
                <span>Productos</span>
                <span>${order.itemsPrice}</span>
              </div>
              <div className="hadacy-order-summary__row">
                <span>Costo de envío</span>
                <span>${order.shippingPrice}</span>
              </div>
              {renderSummaryCouponLines()}
            </div>

            <div className="hadacy-order-summary__divider"></div>

            {userInfo && userInfo.isAdmin && (
              <span className="hadacy-order-summary__admin-tag">
                Admin discount
              </span>
            )}

            <div className="hadacy-order-summary__total">
              <span className="ho-total-label">Total</span>
              <div style={{ textAlign: "right" }}>
                {order.coupon !== null && order.coupon !== undefined ? (
                  <>
                    <span className="hadacy-order-summary__before">
                      ${order.coupon.beforeDiscount}
                    </span>
                    <span className="ho-total-amount">
                      ${order.totalPrice}
                    </span>
                    <div>
                      <span className="hadacy-order-summary__coupon-tag">
                        {order.coupon.Type === "PERCENT"
                          ? `${order.coupon.Name} ${order.coupon.Discount}% OFF`
                          : `${order.coupon.Name} ${
                              order.coupon.appliedDiscountAmount?.toFixed
                                ? "$" +
                                  order.coupon.appliedDiscountAmount.toFixed(
                                    2
                                  ) +
                                  " OFF"
                                : "$" +
                                  order.coupon.appliedDiscountAmount +
                                  " OFF"
                            }`}
                      </span>
                    </div>
                  </>
                ) : (
                  <span className="ho-total-amount">${order.totalPrice}</span>
                )}
              </div>
            </div>

            {!order.isPaid && (
              <div className="hadacy-order-summary__pay">
                {loadingPay && <Loader />}
                {!sdkReady && <Loader />}
                {!preferenceId ? (
                  <Loader />
                ) : (
                  userInfo && (
                    <Wallet
                      className="btn btn-block"
                      initialization={{ preferenceId }}
                      key={preferenceId || "mp-wallet"}
                    />
                  )
                )}
              </div>
            )}

            {loadingDeliver && <Loader />}
            {userInfo &&
              userInfo.isAdmin &&
              order.isPaid &&
              !order.isDelivered && (
                <div className="hadacy-order-summary__pay hadacy-order-deliver">
                  <h3
                    className="hadacy-order-section__title"
                    style={{ fontSize: "1.15rem", marginTop: "0.25rem" }}
                  >
                    Enviar orden
                  </h3>
                  <Form.Group controlId="shippingCompany">
                    <Form.Label
                      style={{
                        fontSize: "0.6rem",
                        letterSpacing: "0.22em",
                        textTransform: "uppercase",
                        color: "var(--muted)",
                        marginBottom: "0.35rem",
                      }}
                    >
                      Compañía de envío
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Ej. DHL"
                      value={shippingCompany || ""}
                      onChange={(e) => setShippingCompany(e.target.value)}
                    />
                  </Form.Group>
                  <Form.Group controlId="shippingNumber">
                    <Form.Label
                      style={{
                        fontSize: "0.6rem",
                        letterSpacing: "0.22em",
                        textTransform: "uppercase",
                        color: "var(--muted)",
                        marginBottom: "0.35rem",
                      }}
                    >
                      Número de rastreo
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Ej. 1Z999AA10123456784"
                      value={shippingNumber || ""}
                      onChange={(e) => setShippingNumber(e.target.value)}
                    />
                  </Form.Group>
                  <Button
                    type="button"
                    className="hadacy-order-deliver__cta"
                    onClick={deliverHandler}
                    disabled={!shippingNumber || !shippingCompany}
                  >
                    Marcar como enviado
                    <i className="fas fa-arrow-right"></i>
                  </Button>
                </div>
              )}
          </aside>
        </Col>
      </Row>
    </div>
  );
};

export default OrderScreen;
